/**
 * 同步 Vant 组件内置文案（Dialog / Picker / Calendar / Toast 等）
 * API：Locale.use(lang, messages)  https://vant-ui.github.io/vant/v2/#/zh-CN/locale
 */
import { Locale } from 'vant'
import zhCN from 'vant/lib/locale/lang/zh-CN'
import zhTW from 'vant/lib/locale/lang/zh-TW'
import enUS from 'vant/lib/locale/lang/en-US'

function unwrap(mod) {
  return mod && mod.default ? mod.default : mod
}

var PACKS = {
  'zh-Hans': { lang: 'zh-CN', messages: unwrap(zhCN) },
  'zh-Hant': { lang: 'zh-TW', messages: unwrap(zhTW) },
  en: { lang: 'en-US', messages: unwrap(enUS) }
}

export function applyVantLocale(appLocale) {
  var pack = PACKS[appLocale] || PACKS['zh-Hans']
  if (!Locale || typeof Locale.use !== 'function') {
    return
  }
  Locale.use(pack.lang, pack.messages)
}



// WEBPACK FOOTER //
// ./src/locale/vantLocale.js